import { Grid, Text, Circle, HStack, VStack, GridItem } from '@chakra-ui/react';

import CardList from './CardList';
import CustomModal from '../CustomModal';
import NextImage from 'shared/NextImage';
import ButtonGoTo from 'shared/ButtonGoTo';

import { defaultCardsData } from 'constants/Service1cModals';
import { DEFAULT_BORDER_RADIUS, DISABLE_SCROLLBAR_STYLE } from 'constants/global';

const Service1cModal = ({ isOpen, onClose, title, subtitle, cardsData }) => (
  <CustomModal isOpen={isOpen} onClose={onClose}>
    <VStack
      w="full"
      maxH="full"
      align="start"
      gap={{ mobile: '20px', tablet: '24px', laptop: '32px' }}
      bgColor="bg.white"
      borderRadius={DEFAULT_BORDER_RADIUS}
      p={{ mobile: '16px', tablet: '20px', laptop: '52px' }}
      overflow="auto"
      sx={DISABLE_SCROLLBAR_STYLE}
      onClick={e => e.stopPropagation()}
    >
      <VStack
        w="full"
        align="start"
        gap={{ mobile: '16px', tablet: '12px', laptop: '20px' }}
        pb={{ laptop: '8px' }}
      >
        <Text as="h2" textStyle="header.h3" fontSize={{ mobile: '24px', laptop: '32px' }}>
          {title}
        </Text>

        <Text
          textStyle="h4"
          fontSize={{ mobile: '16px', laptop: '20px' }}
          maxW={{ laptop: '810px' }}
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      </VStack>

      <Grid
        w="full"
        templateColumns={{ mobile: '1fr', tablet: '1fr 1fr' }}
        gap={{ mobile: '16px', tablet: '20px', laptop: '24px' }}
      >
        {cardsData.map((cardListData, i) => (
          <GridItem
            as={VStack}
            key={`service1cModalCard-${i}`}
            borderRadius={DEFAULT_BORDER_RADIUS}
            p={{ mobile: '16px', laptop: '32px' }}
            align="start"
            gap={{ mobile: '12px', laptop: '20px' }}
            {...defaultCardsData[i].cardProps}
          >
            <HStack gap={{ mobile: '12px', laptop: '16px' }}>
              <Circle
                bgColor="bg.white"
                size={{ mobile: '36px', tablet: '38px', laptop: '48px' }}
                {...defaultCardsData[i].iconCircleBoxProps}
              >
                <NextImage
                  src={defaultCardsData[i].icon}
                  alt="Иконка для карточки"
                  w="auto"
                  h="auto"
                  boxSize={{ mobile: '19px', tablet: '20px', laptop: '24px' }}
                />
              </Circle>

              <Text as="h3" textStyle="header.h4" fontSize={{ mobile: '18px', laptop: '24px' }}>
                {defaultCardsData[i].title}
              </Text>
            </HStack>

            <CardList list={cardListData} cardIndex={i} />
          </GridItem>
        ))}
      </Grid>

      <ButtonGoTo size="secondary" w="full" onBtnClick={onClose} />
    </VStack>
  </CustomModal>
);

export default Service1cModal;
